'use client'
import React, { useState, useEffect } from 'react'
import { getEnvironmentConfig, type EnvironmentConfig } from '@/utilities/getEnvironment'

export const EnvironmentIndicator: React.FC = () => {
  const [envConfig, setEnvConfig] = useState<EnvironmentConfig | null>(null)

  useEffect(() => {
    // Only run on client after mount
    setEnvConfig(getEnvironmentConfig())
  }, [])

  // Don't show anything in production or before mount
  if (!envConfig || !envConfig.showBadge) return null

  return (
    <div
      style={{
        width: '100%',
        padding: '9px',
        borderRadius: '4px',
        backgroundColor: envConfig.bgColor,
        border: `2px solid ${envConfig.color}`,
        textAlign: 'center',
      }}
    >
      <div
        style={{
          fontSize: '11px',
          fontWeight: 'bold',
          color: envConfig.color,
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
        }}
      >
        {envConfig.label} Environment
      </div>
    </div>
  )
}

export default EnvironmentIndicator
